export const VIEW_MODES = {
  DISPLAY: "DISPLAY",
  EDIT: "EDIT"
};
